






























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Banner } from '@/components';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api/index';
import NewsList from './components/NewsList.vue';
import { List } from 'vant';
import {
  getFocus,
  getOnGoing,
  getAcceleration,
  getUnscramble,
  getChengdu,
  getFinancial,
  getLive,
  getCommittee,
} from './api';
Vue.use(List);
@Component({
  components: {
    Banner,
    NewsList,
  },
})
export default class ListPage extends Vue {
  baseInfo = {};
  pointOut = false;
  bannerImg = '';
  loading = false;
  finished = false;
  page = 1;
  getList: any[] = [];
  loadingStatus = true;
  type: any;
  created() {
    this.type = this.$route.query.type;
  }
  onLoad() {
    if (this.loadingStatus) {
      this.loadingStatus = false;
      if (this.type === '1') {
        setTimeout(() => {
          getOnGoing({ page: this.page }).then((res) => this.endNewsData(res));
        }, 150);
      } else if (this.type === '2') {
        setTimeout(() => {
          getAcceleration({ page: this.page }).then((res) =>
            this.endNewsData(res),
          );
        }, 150);
      } else if (this.type === '3') {
        setTimeout(() => {
          getUnscramble({ page: this.page }).then((res) =>
            this.endNewsData(res),
          );
        }, 150);
      } else if (this.type === '4') {
        setTimeout(() => {
          getCommittee({ page: this.page }).then((res) =>
            this.endNewsData(res),
          );
        }, 150);
      } else if (this.type === '5') {
        setTimeout(() => {
          getChengdu({ page: this.page }).then((res) => this.endNewsData(res));
        }, 150);
      } else if (this.type === '6') {
        setTimeout(() => {
          getFinancial({ page: this.page }).then((res) =>
            this.endNewsData(res),
          );
        }, 150);
      } else if (this.type === '7') {
        setTimeout(() => {
          getLive({ page: this.page }).then((res) => this.endNewsData(res));
        }, 150);
      }
    }
  }
  endNewsData(res: any) {
    if (!res.data) {
      this.finished = true;
    } else {
      this.getList = [...this.getList, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = true;
  }
}
